import { type ReactElement, useEffect } from 'react'
import toast from 'react-hot-toast'
import { useLocation } from 'react-router-dom'
import LoadingScreen from '../common/LoadingScreen'
import NoHasInterface from '../common/NoHasInterface'
import { useAppSelector } from '@store/stores'
import { selectInterfacesByOrganization, selectUser, selectUserRole } from '@store/selectors/UserSelector'
import {
  selectInterfacesByOrganizationLoading,
} from '@store/slices/interfaceByOrganization/interfaceByOrganizationSlice'

interface RequireHasInterfaceProps {
  roles: string[]
  children: ReactElement
  redirectTo: string
}

const RequireHasInterface = ({
                               roles,
                               redirectTo,
                               children,
                             }: RequireHasInterfaceProps) => {
  const { pathname: from } = useLocation()

  const user = useAppSelector(selectUser)
  const userRole = useAppSelector(selectUserRole)
  const isIncludes = roles.includes(String(userRole))

  const data = useAppSelector(selectInterfacesByOrganization)
  const isLoading = useAppSelector(selectInterfacesByOrganizationLoading)

  useEffect(() => {
    if (!isIncludes) return
    if (!isLoading && !data?.length)
      toast.error(
        'No interface has been assigned yet or interface has been pending setup, please contact your administrator for support!',
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.length, isLoading])

  if (!isIncludes) {
    return children
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  // if (
  //   from !== CONFIG_SETUP_ROUTES.index.to &&
  //   data?.length > 0 &&
  //   data[0]?.status === false
  // ) {
  //   return <Navigate to={CONFIG_SETUP_ROUTES.index.to} />
  // }

  // if (from !== OPERATIONS_ROUTES.index.to && data?.length > 0) {
  //   return <Navigate to={OPERATIONS_ROUTES.index.to} />
  // }

  const hasActiveInterface =
    data && data?.some((item: any) => item.status === true)

  if (user && hasActiveInterface) {
    return children
  }

  return <NoHasInterface />
}

export default RequireHasInterface
